/**
 * File: 05-view-counter.js
 *
 * Handles view counting for both single pages and infinite scroll.
 * Uses IntersectionObserver for individual posts and MutationObserver
 * to detect new posts loaded via AJAX.
 */
document.addEventListener('DOMContentLoaded', () => {
    // Контейнер, в который подгружаются новые посты. Измените, если у вас другой.
    const contentContainer = document.querySelector('#main, .site-main, main'); 
    
    // Проверяем, что глобальные данные и контейнер существуют
    if (!contentContainer || typeof saborlistaSingle === 'undefined') {
        return;
    }

    // --- Логика для одного трекера (IntersectionObserver) ---
    const handleIntersection = (entries, observer) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                const tracker = entry.target;
                const postId = tracker.dataset.postId;
                if (postId) {
                    const endpoint = `${saborlistaSingle.restUrl}saborlista/v1/view/${postId}`;
                    fetch(endpoint, {
                        method: 'POST',
                        headers: { 'X-WP-Nonce': saborlistaSingle.nonce },
                    })
                    .then(async (response) => {
                        let data = null;
                        try {
                            data = await response.json();
                        } catch (_) {}
                        if (!response.ok || !data || !data.success) {
                            console.error(saborlistaSingle.i18n.viewCountFail, {
                                postId,
                                status: response.status,
                                data
                            });
                        }
                    })
                    .catch((error) => {
                        console.error(saborlistaSingle.i18n.viewCountNetworkError, error);
                    });
                }
                // Отключаем наблюдение после срабатывания
                observer.unobserve(tracker);
            }
        });
    };

    const intersectionObserver = new IntersectionObserver(handleIntersection, { threshold: 0.5 });

    // --- Функция для инициализации наблюдения за трекером ---
    const observeTracker = (trackerElement) => {
        intersectionObserver.observe(trackerElement);
    };

    // --- Обрабатываем трекеры, которые уже есть на странице при загрузке ---
    const initialTrackers = contentContainer.querySelectorAll('.post-view-tracker');
    initialTrackers.forEach(observeTracker);

    // --- Логика для отслеживания новых постов (MutationObserver) ---
    const mutationCallback = (mutationsList) => {
        for (const mutation of mutationsList) {
            if (mutation.type === 'childList') {
                mutation.addedNodes.forEach(node => {
                    // Проверяем, что добавленный узел - это элемент (а не текст, например)
                    if (node.nodeType === 1) { 
                        // Ищем наш трекер внутри нового элемента
                        const newTrackers = node.querySelectorAll('.post-view-tracker');
                        newTrackers.forEach(observeTracker);
                    }
                });
            }
        }
    };

    const mutationObserver = new MutationObserver(mutationCallback);
    // Начинаем следить за контейнером: ждём добавления дочерних элементов
    mutationObserver.observe(contentContainer, { childList: true, subtree: true });
});